import React from 'react';
import styled, { css } from "styled-components";
import { getAppThemeName } from "../../../services/appTheme";
const StyledPage = styled.div `
  overflow-y: hidden;
  overflow-x: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: 100%;

  @media only screen and (min-width: 576px) {
    padding-top: 140px;
  }
  
  @media only screen and (min-width: 768px) {
    padding: 0;
  }
    overflow-y: auto;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  }
  
  ${props => props.appThemeName === "inkassier" && css `
        background-image: url("/img/wallpaper.png");
        background-position: center center;
        background-size: cover;
        background-repeat: no-repeat;
    
    @media only screen and (min-width: 768px) {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
    }
 `};
  
  ${props => props.appThemeName === "invoned" && css `
    font-family: ${props => props.theme.fontBase};
    background-color: ${props => props.theme.accent};

    @media only screen and (min-width: 1200px) {
      background-color: ${props => props.theme.accent};

      &:before {
        content: none;
      }
    }
  `};
`;
const IdealPage = ({ children }) => (React.createElement(StyledPage, { appThemeName: getAppThemeName() }, children));
export default IdealPage;
